import { Link } from 'react-router-dom';

const BreadcrumbItem = ({ to, children, className = '' }) => (
    <Link to={to} className={className}>
        {children}
    </Link>
);

export default BreadcrumbItem;
